import * as React from 'react';

const ArrowClock24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 2c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10-4.611 0-8.483-3.126-9.64-7.37l1.448-.396C4.792 17.84 8.087 20.5 12 20.5c4.687 0 8.5-3.813 8.5-8.5 0-4.688-3.813-8.5-8.5-8.5-3.34 0-6.227 1.94-7.614 4.75H8v1.5H2v-6h1.5v2.993A9.98 9.98 0 0 1 12 2Zm-.75 5h1.5v4.625l3.7 2.775-.9 1.2-4.3-3.225V7Z"
  }
)));
ArrowClock24.Size = 24;
ArrowClock24.Title = "ArrowClock";

export { ArrowClock24 as default };
